import { Tag, TagLabel } from '@chakra-ui/react'
import React from 'react'

interface Props {
    classification : string
}

const Classification : React.FC<Props> = ({classification}) => {
  return (
    <Tag
      size={"md"}
      borderRadius='full'
      variant='solid'
      colorScheme={classification === "Normal" ? "green" : classification === "Complexe" ? "red" : "orange" }
    >
      <TagLabel>{classification}</TagLabel>
    </Tag>
  )
}

export default Classification